import React, { useEffect, useState } from "react";
import Layout from "../pages/Layout";
import config from "../config";
import { useNavigate } from "react-router-dom";
import HomeIcon from "../assets/icons/home_icon"
import TransparentLogo from "../images/bentex-logo-trans.png"
import PencilIcon from "../assets/icons/pencil_icon";
import userImage from "../assets/icons/user.png"
import { toast } from 'react-toastify';


const AddCustomer = () => {
  const navigate = useNavigate();

  const [customerData, setCustomerData] = useState({
    customer_name: "",
    mobile: "",
    email: "",
    address: "",
    customer_type: "",
  });

  const [profilePicture, setProfilePicture] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);
  const [isSaveDisable, setIsSaveDisable] = useState(true);

  useEffect(() => {
    const { customer_name, email } = customerData;
    const emailIsValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    if (customer_name.trim().length > 0 && emailIsValid) {
      setIsSaveDisable(false);
    } else {
      setIsSaveDisable(true);
    }
  }, [customerData.customer_name, customerData.email]);


  // console.log(isSaveDisable)
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setCustomerData({
      ...customerData,
      [name]: value,
    });
  };

  const handleFileChange = (e) => {
    setProfilePicture(e.target.files[0]);
  };

const handleSave = async () => {
  const { customer_name, email, mobile } = customerData;

  // Validation checks
  if (!customer_name.trim()) {
    toast.error("Customer name is required.");
    return;
  }

  if (!mobile.trim()) {
    toast.error("Mobile number is required.");
    return;
  }

  const emailIsValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  if (!email.trim()) {
    toast.error("Email is required.");
    return;
  }

  if (!emailIsValid) {
    toast.error("Please enter a valid email address.");
    return;
  }

  try {
    const formData = new FormData();
    formData.append("customer_name", customer_name);
    formData.append("mobile", mobile);
    formData.append("email", email);
    formData.append("address", customerData.address);
    formData.append("customer_type", customerData.customer_type);

    if (profilePicture) {
      formData.append("profile_picture", profilePicture);
    }

    const response = await fetch(`${config.BASE_URL}/api/v1/add`, {
      method: "POST",
      body: formData,
    });

    const result = await response.json();

    if (response.status === 201) {
      toast.success("Customer added successfully!");
      setCustomerData({ customer_name: "", mobile: "", email: "", address: "" });
      setProfilePicture(null);
      navigate("/customer-detail/" + result.customer._id);
    } else {
      toast.error(result.message || "Failed to add customer.");
    }
  } catch (error) {
    console.error("Error occurred while saving data:", error);
    toast.error("Something went wrong.");
  }
};


  const handleCancel = () => {
    setCustomerData({ customer_name: "", mobile: "", email: "", address: "" });
    setProfilePicture(null);
  };

  return (
    <Layout>
      <div className="add-customer-page">
        <header className="header">
          <h1>New Customer</h1>
          <p><HomeIcon /> / Customers / New Customer</p>
        </header>

        <div className="add_page_inner">
          <div className="tr_logo">
            <img src={TransparentLogo} alt="" />
          </div>
          <div className="form-container">
            <div className="avatar-section">
              <img
                src={
                  profilePicture
                    ? URL.createObjectURL(profilePicture)
                    : userImage
                }
                alt="Avatar"
                className="avatar"
              />
              <label className="edit-avatar-btn">
                <PencilIcon />
                <input
                  type="file"
                  accept="image/*"
                  style={{ display: "none" }}
                  onChange={handleFileChange}
                />
              </label>
            </div>
            <form className="customer-form" onSubmit={(e) => e.preventDefault()} >
              <div className="form_field">
                <label htmlFor="customer_name"> Customer Name*</label>
                <input type="text" name="customer_name" value={customerData.customer_name} onChange={handleInputChange} />
              </div>
              <div className="form_field">
                <label htmlFor="mobile">Mobile* </label>
                <input type="tel" name="mobile" value={customerData.mobile} onChange={handleInputChange} />
              </div>
              <div className="form_field">
                <label htmlFor="email">Email* </label>
                <input type="email" name="email" value={customerData.email} onChange={handleInputChange} />
              </div>
              <div className="form_field">
                <label htmlFor="address">Address </label>
                <input type="text" name="address" value={customerData.address} onChange={handleInputChange} />
              </div>

              <div className="form_field">
                <label htmlFor="customer_type">Customer Type</label>
                <select
                  name="customer_type"
                  value={customerData.customer_type}
                  onChange={handleInputChange}
                  required
                >
                  <option value="">Select Type</option>
                  <option value="Special Occasion">Special Occasion</option>
                  <option value="Business">Business</option>
                </select>
              </div>


              <div className="form-buttons">
                <button
                  type="button"
                  className="save-btn"
                 
                  onClick={handleSave}
                >
                  Save
                </button>
                <button
                  type="button"
                  className="cancel-btn"
                  onClick={handleCancel}
                >
                  Cancel
                </button>
              </div>
            </form>

            {errorMessage && <p style={{ color: "red" }}>{errorMessage}</p>}

          </div>
        </div>
      </div>
    </Layout>
  );
};

export default AddCustomer;
